module.exports = {
    "Empty": `Tuk\u{161}s`
};


//# sourceMappingURL=lv-LV.main.js.map
